<div class="fade-in">
  <ng-container *ngIf="{ profile: userProfile$ | async, perms: pagePermissions$ | async } as data">
    <!-- If Owner KPI is permitted for the user's role, show the financial hero banner + KPI component -->
    <ng-container *ngIf="canAccess('owner-kpi', data.profile?.role, data.perms); else welcomeOnly">
      <div class="hero-banner">
        <div class="hero-text">
          <h1>{{ greeting }}</h1>
          <p>Here is the financial overview for Venture 2020 Inc.</p>
        </div>
        <div class="hero-graphic">📈</div> 
      </div>

      <app-owner-kpi></app-owner-kpi>
    </ng-container>

    <!-- When Owner KPI / Dashboard is not allowed for the role, show a friendly welcome card -->
    <ng-template #welcomeOnly>
      <div class="welcome-card">
        <div class="welcome-icon-wrapper">
          <span class="welcome-icon">👋</span>
        </div>
        <div class="welcome-content">
          <h1 class="welcome-title">{{ greeting }}, {{ getUserDisplayName(data.profile) }}!</h1>
          <p class="welcome-subtitle">Welcome to the KCEG Enterprise Operations Portal.</p>
          <div class="welcome-info-box">
            <p class="welcome-instructions">
              Please use the top navigation menu or the sidebar to access your assigned operational tools and reports.
            </p>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>